<template>
    <v-sheet style="background-color:#fff;height:100%;">
        <v-toolbar elevation="0" style="border-bottom:1px solid #ddd;" pb-1>
            <v-toolbar-title>PRODUTOS</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <!-- <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="video_tela = true" text color="red">
                        <v-icon>video_call</v-icon>&nbsp; ENVIAR VÍDEOS
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn @click="video_tela = true" text color="red">
                        <v-icon>video_call</v-icon>
                    </v-btn>
                </template>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="open_product_edit(null)" text color="primary">
                        <v-icon>add</v-icon>&nbsp; Produto
                    </v-btn>
                </template> 
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn @click="open_product_edit(null)" text color="primary">
                        <v-icon>add</v-icon>
                    </v-btn>
                </template> -->
            </v-toolbar-items>
        </v-toolbar>
        <v-container fill-height v-if="load_feito">
            <v-layout wrap text-center justify-center>
                <v-flex xs12 v-if="produtos.length>0">
                    <v-layout wrap>
                        <v-flex xs12 sm4 lg3 py-2 v-for="produto in produtos" :key="produto.id">
                            <v-card class="mx-auto" max-width="250px">
                                <v-img
                                    v-if="produto.thumbnail!=null"
                                    :src="get_img_url(produto.thumbnail)"
                                    width="250px"
                                ></v-img>
                                <v-card-title oneline>
                                    <div style="width:100%">{{produto.name}}</div>
                                    <span class="grey--text subtitle-1">{{produto.artist_name}}</span>
                                </v-card-title>
                                <v-card-actions>
                                    <v-img
                                        v-if="produto.flavor=='video'"
                                        src="@/assets/youtube_logo_animated.gif"
                                        style="height:50px;width:70px"
                                    />
                                    <v-spacer></v-spacer>
                                    <v-menu bottom left dense>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon v-on="on">
                                                <v-icon>more_vert</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-list dense>
                                            <v-list-item @click="open_product_edit(produto)">
                                                <v-list-item-title>EDITAR</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item
                                                @click="delete_product(produto)"
                                                v-if="(produto.status == 'draft')"
                                            >
                                                <v-list-item-title>REMOVER</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="open_product_view(produto)">
                                                <v-list-item-title>VISUALIZAR</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <v-flex xs12 v-show="produtos.length==0 && load_feito">
                    <v-layout align-center text-center style="height:100%">
                        <v-flex xs12>
                            <h1 class="display-1 mb-5">
                                <span class="font-weight-bold">Criador,</span> os seus produtos contam histórias
                            </h1>
                            <p class="subheading font-weight-regular my-5">
                                Conte-nos sobre a sua história através das suas músicas.
                                <br />
                                <br />
Cada faixa musical que você produz tem muito trabalho e muito suor, e nós sabemos disso.
                                <br />Distribua aqui seu Single, Ep ou Álbum para todas as plataformas digitais e compartilhe com o mundo a sua história.
                            </p>
                            <p>
                                <v-btn
                                    @click="open_product_edit(null)"
                                    color="green"
                                    dark
                                    elevation="0"
                                >
                                    <v-icon>mdi-plus</v-icon>COMEÇAR
                                </v-btn>
                            </p>
                            <p class="subheading font-weight-regular my-5">
                                <b>#Dica</b> - Primeiro faça o cadastro das obras musicais que fazem parte do seu Single, EP, Álbum. Dessa forma você otimiza a distribuição do seu conteúdo.
                            </p>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <modalmessage
                    :dialog_opened="message.dialog_opened"
                    :title="message.title"
                    :message="message.message"
                    btn_1_text="adicionar informações"
                    @btn_1_clicked="modalmessage_entendi"
                    ref="modal"
                />
            </v-layout>

            <v-dialog
                v-model="video_tela"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="success">
                        <v-btn icon dark @click="video_tela = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>ENVIO DE VÍDEOS</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                        <v-toolbar-items></v-toolbar-items>
                    </v-toolbar>
                    <v-sheet class="py-5 px-5">
                        <div class="subheading font-weight-regular">
                            <h2>O que você precisa saber antes de enviar seu vídeo</h2>
                            <br />
                            <hr style="border-color:#eee" />
                            <br />
                        </div>
                        <p class="subheading font-weight-regular">
                            <b>-</b>Não analisamos vídeos caseiros ou amadores
                            <br />
                            <br />
                            <b>-</b>Não analisamos vídeos com letras ou fotos paradas
                            <br />
                            <br />
                            <b>-</b>Não analisamos áudios isoladamente
                            <br />
                            <br />
                            <b>-</b>Para que seu vídeo seja analisado ele precisa ter sido gravado profissionalmente e com qualidade mínima de 1080p (FullHD)
                            <br />
                            <br />
                            <br />
                            <br />
                        </p>

                        <div class="subheading font-weight-regular">
                            <h2>Saiba como enviar o seu vídeo para aprovação</h2>
                            <br />
                            <hr style="border-color:#eee" />
                            <br />
                        </div>
                        <p class="subheading font-weight-regular">
                            <b>1 - ENVIO</b>
                            <br />Se o seu vídeo se encaixa nos requisitos acima, por favor, envie o link do mesmo para o e-mail videos@novamusicagospel.com.br.
                            Você pode mandar o link do seu vídeo usando um serviço de armazenamento em nuvem, como: DropBox, Google Drive, One Drive, WeTransfer ou YouTube
                            com o status de privacidade como "Não Listado".
                            <br />
                            <br />

                            <b>2 - ANÁLISE</b>
                            <br />Em até 7 dias, você receberá um retorno com a avaliação do material enviado. Caso tenha sido
                            <b>aprovado</b>,
                            um novo item ficará disponível no menu "PRODUTOS" dentro da plataforma Nova Música Gospel.
                            <br />
                            <br />

                            <b>3 - PUBLICAÇÃO</b>
                            <br />Após preencher todos os dados do seu vídeo para publicação e confirmar o pagamento, ele será disponibilizado no
                            canal do Nova Música Gospel no YouTube na data agendada para o lançamento.
                            <br />
                            <br />
                        </p>
                        <div class="text-center pt-5">
                            <v-btn
                                color="red"
                                dark
                                elevation="0"
                                large
                                href="mailto:videos@novamusicagospel.com.br"
                            >ENVIAR EMAIL</v-btn>
                        </div>
                    </v-sheet>
                </v-card>
            </v-dialog>
        </v-container>
    </v-sheet>
</template>

<script>
import ProductService from "../../../app/Rest/product";
import modalmessage from "../../../components/shared/modalmessage";
import { setTimeout } from "timers";

let productService = null;
export default {
    components: {
        modalmessage,
    },
    data: () => ({
        produtos: [],
        load_feito: false,
        video_tela: false,
        message: {
            dialog_opened: false,
            title: "",
            message: "",
            btn_1_text: "",
        },
    }),
    created: function () {
        this.load_products();
    },

    methods: {
        load_products() {
            // this.$store.commit("loading");
            productService = ProductService.build();
            this.$store.commit("loading");
            productService
                .getAll()
                .then((e) => {
                    this.produtos = e.items;
                })
                .finally(() => {
                    this.load_feito = true;
                    setTimeout(() => {
                        this.$store.commit("loading", false);
                    }, 1500);
                });
        },
        modalmessage_entendi() {
            this.message.dialog_opened = false;
            //return this.$router.push( {name:'settings', params:{tab:this.$store.getters.global_alert_showing.tab}});
        },
        delete_product(product) {
            var load_products = this.load_products;
            this.$refs.modal.show({
                title: "Certeza que deseja remover?",
                message: "Não é possível recuperar o produto após remoção.",
                btn_1_text: "Cancelar",
                btn_1_action: function () {},
                btn_2_text: "SIM, QUERO REMOVER",
                btn_2_action: function () {
                    this.$store.commit("loading");
                    productService
                        .delete(product.id)
                        .then((e) => {
                            if ((e.status = "ok")) {
                                load_products();
                            } else {
                                this.$refs.modal.show({
                                    title: e.msg,
                                    btn_1_text: "entendi",
                                });
                            }
                        })
                        .finally((e) => {
                            this.$store.commit("loading", false);
                        });
                },
                params: {
                    btn_1_color: "primary",
                    btn_2_color: "red",
                },
            });
        },
        open_product_view(product) {
            if (product == null) {
                return false;
            }

            this.$router.push({
                name: "product_view",
                params: { id: product.id },
            });
        },
        open_product_edit(product) {
            //obrigatoriedade dos dados de endereço e obras antes de continuar a criar um produto
            if (this.$store.getters.global_alert_showing.msg != "") {
                return this.$refs.modal.show({
                    title: "Antes de continuar...",
                    message: this.$store.getters.global_alert_showing.msg,
                    btn_1_text: "CADASTRAR AGORA",
                    btn_1_action: function () {
                        return this.$router.push({
                            name: "settings",
                            params: {
                                tab: this.$store.getters.global_alert_showing
                                    .tab,
                            },
                        });
                    },
                });
            }
            if (product == null) {
                return this.$router.push({ name: "product_add" });
            }
            if (
                product.status == "draft" ||
                product.status.indexOf("editable") >= 0
            ) {
                var router_push = {
                    name: "product_edit",
                    params: { id: product.id },
                };
                //verificamos se é video enviando para uma página diferente
                if (product.flavor == "video") {
                    router_push.name = "product_edit_video";
                }

                this.$router.push(router_push);
            } else {
                this.$refs.modal.show(
                    "Produto em Processamento",
                    "Seu produto está em fila de procesamento.<br><br>Fique atento ao e-mail e ao celular pois podemos entrar em contato para pedir mais informações sobre o seu produto.",
                    "Entendi"
                );
            }
        },
        get_img_url(cover_path) {
            return cover_path.indexOf("googleapis") >= 0
                ? cover_path
                : process.env.VUE_APP_BASE_URL + cover_path;
            //return process.env.VUE_APP_BASE_URL + cover_path;
        },
    },
};
</script>
